import {
    ChangeEvent, DropdownItem, ExcludableTextbox, LookupModelSearchEvent, Snackbar
} from "@mcleod/components";
import { AutogenLayoutStatusDurationReport } from "./autogen/AutogenLayoutStatusDurationReport";

export class StatusDurationReport extends AutogenLayoutStatusDurationReport {
    override onLoad(): void | Promise<void> {
        this.textboxOutbondFrom.selectedItem = this.textboxOutbondFrom.items[0];
        this.textboxInboundTo.selectedItem = this.textboxInboundTo.items[0];
        this.textboxMovStatus.selectedItem = this.textboxMovStatus.items[0];
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxMinute.minValue = 0;
    }

    textboxInboundToOnChange(event: ChangeEvent) {
        if (this.textboxInboundTo.selectedItem && this.textboxInboundTo.selectedItem.displayValue !== "None") {
            this.excludabletextboxInboundLookup.textbox.clear();
            this.excludabletextboxInboundLookup.enabled = true;
            this.excludabletextboxInboundLookup.visible = true;
            const selectedItem = this.textboxInboundTo.text;
            this.setupInboundLookup(selectedItem, this.excludabletextboxInboundLookup, "Inbound To");
        } else {
            this.excludabletextboxInboundLookup.enabled = false;
            this.excludabletextboxInboundLookup.visible = false;
            this.textboxGroupBy.items[7].displayValue = "Inbound";
        }
        if((this.textboxGroupBy.items as DropdownItem[]).find(item => item.value.toLocaleLowerCase() === "inbound")) {
            this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        }
    }

    textboxOutboundFromOnChange(event: ChangeEvent) {
        if (this.textboxOutbondFrom.selectedItem && this.textboxOutbondFrom.selectedItem.displayValue !== "None") {
            this.excludabletextboxOutbountLookup.textbox.clear();
            this.excludabletextboxOutbountLookup.enabled = true;
            this.excludabletextboxOutbountLookup.visible = true;
            const selectedItem = this.textboxOutbondFrom.text;
            this.setupOutboundLookup(selectedItem, this.excludabletextboxOutbountLookup, "Outbound From");
        } else {
            this.excludabletextboxOutbountLookup.enabled = false;
            this.excludabletextboxOutbountLookup.visible = false;
            this.textboxGroupBy.items[6].displayValue = "Outbound";
        }
        if((this.textboxGroupBy.items as DropdownItem[]).find(item => item.value.toLocaleLowerCase() === "outbound")) {
            this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        }
    }

    private setupInboundLookup(selectedItem: string, textboxLookup: ExcludableTextbox, captionDescription: string) {
        const groupByIB = (this.textboxGroupBy.items as DropdownItem[]).find(item => item.value.startsWith("Inbound"));
        switch (selectedItem) {
            case "State": {
                textboxLookup.textbox.lookupModelDisabled = false;
                textboxLookup.textbox.caption = captionDescription + " (State)";
                textboxLookup.textbox.lookupModel = "common/states";
                textboxLookup.textbox.lookupModelLayout = "common/States";
                textboxLookup.textbox.lookupModelDisplayField = "name";
                textboxLookup.textbox.lookupModelResultField = "id";
                textboxLookup.textbox.lookupModelAllowMultiSelect = true;
                textboxLookup.textbox.lookupModelMinChars = 2;
                groupByIB.displayValue = "Inbound State";
                break;
            }
            case "Zone": {
                textboxLookup.textbox.lookupModelDisabled = false;
                textboxLookup.textbox.caption = captionDescription + " (Zone)";
                textboxLookup.textbox.lookupModel = "lme/general/zones";
                textboxLookup.textbox.lookupModelLayout = "lme/general/Zones";
                textboxLookup.textbox.lookupModelDisplayField = "descr";
                textboxLookup.textbox.lookupModelResultField = "id";
                textboxLookup.textbox.lookupModelAllowMultiSelect = true;
                groupByIB.displayValue = "Inbound Zone";
                break;
            }
            case "Location": {
                textboxLookup.textbox.lookupModelDisabled = false;
                textboxLookup.textbox.caption = captionDescription + " (Location)";
                textboxLookup.textbox.lookupModel = "lme/dispatch/location";
                textboxLookup.textbox.lookupModelLayout = "lme/dispatch/LocationLookup";
                textboxLookup.textbox.lookupModelDisplayField = "name";
                textboxLookup.textbox.lookupModelResultField = "id";
                textboxLookup.textbox.lookupModelAllowMultiSelect = true;
                groupByIB.displayValue = "Inbound Location";
                break;
            }
            case "Zip":
                textboxLookup.textbox.lookupModelDisabled = true;
                textboxLookup.textbox.caption = captionDescription + " (Zip)";
                textboxLookup.textbox.text = this.makeFauxLookupModelValue(textboxLookup.textbox.text)
                groupByIB.displayValue = "Inbound Zip";
                break;
        }
        if(this.isUserInputValid()){
            this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0]
            this.textboxGroupBy.selectedItem = groupByIB
        }
    }

    private setupOutboundLookup(selectedItem: string, textboxLookup: ExcludableTextbox, captionDescription: string) {
        const groupByOB = (this.textboxGroupBy.items as DropdownItem[]).find(item => item.value.startsWith("Outbound"));
        switch (selectedItem) {
            case "State": {
                textboxLookup.textbox.lookupModelDisabled = false;
                textboxLookup.textbox.caption = captionDescription + " (State)";
                textboxLookup.textbox.lookupModel = "common/states";
                textboxLookup.textbox.lookupModelLayout = "common/States";
                textboxLookup.textbox.lookupModelDisplayField = "name";
                textboxLookup.textbox.lookupModelResultField = "id";
                textboxLookup.textbox.lookupModelAllowMultiSelect = true;
                textboxLookup.textbox.lookupModelMinChars = 2;
                groupByOB.displayValue = "Outbound State";
                break;
            }
            case "Zone": {
                textboxLookup.textbox.lookupModelDisabled = false;
                textboxLookup.textbox.caption = captionDescription + " (Zone)";
                textboxLookup.textbox.lookupModel = "lme/general/zones";
                textboxLookup.textbox.lookupModelLayout = "lme/general/Zones";
                textboxLookup.textbox.lookupModelDisplayField = "descr";
                textboxLookup.textbox.lookupModelResultField = "id";
                textboxLookup.textbox.lookupModelAllowMultiSelect = true;
                groupByOB.displayValue = "Outbound Zone";
                break;
            }
            case "Location": {
                textboxLookup.textbox.lookupModelDisabled = false;
                textboxLookup.textbox.caption = captionDescription + " (Location)";
                textboxLookup.textbox.lookupModel = "lme/dispatch/location";
                textboxLookup.textbox.lookupModelLayout = "lme/dispatch/LocationLookup";
                textboxLookup.textbox.lookupModelDisplayField = "name";
                textboxLookup.textbox.lookupModelResultField = "id";
                textboxLookup.textbox.lookupModelAllowMultiSelect = true;
                groupByOB.displayValue = "Outbound Location";
                break;
            }
            case "Zip":
                textboxLookup.textbox.lookupModelDisabled = true;
                textboxLookup.textbox.caption = captionDescription + " (Zip)";
                textboxLookup.textbox.text = this.makeFauxLookupModelValue(textboxLookup.textbox.text)
                groupByOB.displayValue = "Outbound Zip";
                break;
        }
        if(this.isUserInputValid() ){
            this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0]
            this.textboxGroupBy.selectedItem = groupByOB
        }
    }

    private makeFauxLookupModelValue(value: string): string {
        // Remove any characters that are not numbers or commas
        const cleanedValue = value.replace(/[^0-9,]/g, '');

        // Prepend "in " if there are multiple items
        const items = cleanedValue.split(',').filter(item => item.trim() !== '');
        return items.length > 1 ? `in ${items.join(',')}` : cleanedValue;
    }

    switchReportOnChange(event: ChangeEvent){
        const isChecked = this.switchReport.checked;
        this.textboxMovStatus.visible = isChecked;
        this.textboxMovStatus.enabled = isChecked;
        this.textboxBrokerageStatus.visible = !isChecked;
        this.textboxBrokerageStatus.enabled = !isChecked;
        this.switchStatusDuration.checked = true;
        if (!this.brokerageHasData()){
            this.switchStatusDuration.enabled = false;
            this.textboxMinute.text = "0";
        }
        else {
            this.switchStatusDuration.enabled = true;
        }
        if(isChecked){
            this.textboxMovStatus.selectedItem = (this.textboxMovStatus.items as DropdownItem[]).find(item => item.value.startsWith("All"));
        }
    }

    textboxMovStatusOnChange(event: ChangeEvent) {
        if (this.textboxMovStatus.selectedItem?.displayValue === "All") {
            this.textboxMinute.text = "0";
            this.switchStatusDuration.checked = true;
            this.switchStatusDuration.enabled = this.brokerageHasData();
        } else {
            this.switchStatusDuration.enabled = true;
        }
    }

    brokerageHasData(): boolean{
        if(!this.textboxBrokerageStatus.lookupModelData){
            return false;
        }
        return true;
    }

    onLookupModelSelectionBrokerageStatus(event: LookupModelSearchEvent) {
        if (this.brokerageHasData()) {
            this.switchStatusDuration.enabled = true;
        } else {
            this.switchStatusDuration.enabled = false;
            this.textboxMinute.text = "0";
        }
    }

    textboxGroupByOnChange(event: ChangeEvent) {
        const item = this.textboxGroupBy.selectedItem?.value;
        if(!this.isUserInputValid()) {
            this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
            if(item.toLocaleLowerCase() == "inbound"){
                Snackbar.showWarningSnackbar("Please select inbound type before grouping by Inbound");
            }
            else if(item.toLocaleLowerCase() == "outbound"){
                Snackbar.showWarningSnackbar("Please select outbound type before grouping by Outbound");
            }
        }
    }

    private isUserInputValid(): boolean {
        if (this.textboxGroupBy.selectedItem?.displayValue.toLowerCase() === "inbound" && this.textboxInboundTo.selectedItem?.displayValue.toLowerCase() === "none") {
            return false
        }
        else if (this.textboxGroupBy.selectedItem?.displayValue.toLowerCase() === "outbound" && this.textboxOutbondFrom.selectedItem?.displayValue.toLowerCase() === "none") {
            return false
        }
        return true;
    }

    outboundFromBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        if(this.excludabletextboxOutbountLookup.textbox.isEmpty()){
            this.excludabletextboxOutbountLookup.checkbox.checked = false;
            this.excludabletextboxOutbountLookup.checkbox.enabled = false;
        }
    }

    inboundToBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        if(this.excludabletextboxInboundLookup.textbox.isEmpty()){
            this.excludabletextboxInboundLookup.checkbox.checked = false;
            this.excludabletextboxInboundLookup.checkbox.enabled = false;
        }
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.type_of = "C"
    }

    textboxDispatchersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.web_user_type = "E || U"
    }

    textboxOrderTypesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = "Y"
    }

}
